import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const url = '/secure/policies/intune/deviceAppManagement-mobileAppConfigurations'

export const intuneMobileAppConfigurationsApi = createApi({
  reducerPath: 'intuneMobileAppConfigurations',
  tagTypes: ['MobileAppConfiguration'],
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getMobileAppConfigurations: builder.query({
      query: (customerId) => ({
        url,
        params: { customerId },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'MobileAppConfiguration', id })),
              { type: 'MobileAppConfiguration', id: 'LIST' },
            ]
          : [{ type: 'MobileAppConfiguration', id: 'LIST' }],
    }),
    getMobileAppConfigurationById: builder.query({
      query: ({ customerId, policyId }) => ({
        url: `${url}/${policyId}`,
        params: { customerId },
      }),
      providesTags: (result, error, { policyId }) => [{ type: 'MobileAppConfiguration', id: policyId }],
    }),
    deleteMobileAppConfiguration: builder.mutation({
      query: ({ customerId, userId, policyId }) => ({
        url,
        params: { customerId, userId, policyId },
        method: 'DELETE',
      }),
    }),
    createMobileAppConfiguration: builder.mutation({
      query: ({ customerId, userId, payload, source }) => ({
        url,
        body: payload,
        params: { customerId, userId, source },
        method: 'POST',
      }),
    }),
    updateMobileAppConfiguration: builder.mutation({
      query: ({ customerId, userId, policyId, payload }) => ({
        url: `${url}/${policyId}`,
        body: payload,
        params: { customerId, userId },
        method: 'PUT',
      }),
    }),
  }),
})

export const {
  useGetMobileAppConfigurationsQuery,
  useLazyGetMobileAppConfigurationsQuery,
  useGetMobileAppConfigurationByIdQuery,
  useLazyGetMobileAppConfigurationByIdQuery,
  useDeleteMobileAppConfigurationMutation,
  useCreateMobileAppConfigurationMutation,
  useUpdateMobileAppConfigurationMutation,
} = intuneMobileAppConfigurationsApi

export const useGetMobileAppConfigurations = () => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetMobileAppConfigurationsQuery(customerId)
}

export const useGetMobileAppConfigurationById = ({ policyId }, options) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetMobileAppConfigurationByIdQuery({ customerId, policyId }, options)
}
